<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('pages.kakao-chennel-reg')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card>
          <b-form-group label-cols="2" horizontal label="카카오톡 채널" class="weight600">
            <b-row>
              <b-colxx xxs="6" xl="4">
                <b-input-group v-if="!partnerId">
                  <b-form-input placeholder="사업자번호" maxlength="12" v-model="businessCode"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-primary default" @click="searchBusinessCode">채널검색</b-button>
                  </b-input-group-append>
                </b-input-group>
                <span v-else>{{ getSelectedChannelInfo() }}</span>
              </b-colxx>
              <b-colxx xxs="6" xl="5">
                <b-form-select v-if="!partnerId"  plain v-model="selectedKakaoChannel" @change="initKakaoPartner">
                  <b-form-select-option v-if="!successChk" :value="null">채널을 검색해주세요.</b-form-select-option>
                  <template v-for="(kcitem, kcidx) in kakaoChannelList">
                    <b-form-select-option v-if="!kcitem.id"  :value="null">{{kcitem.name}} </b-form-select-option>
                    <b-form-select-option v-else-if="selectedKakaoChannel!=null && kcitem.searchId === selectedKakaoChannel.searchId" :value="selectedKakaoChannel">
                      {{ selectedKakaoChannel.name + " (" + selectedKakaoChannel.searchId + ")" }}
                    </b-form-select-option>
                    <b-form-select-option v-else :value="kcitem">{{ kcitem.name + " (" + kcitem.searchId + ")" }}</b-form-select-option>
                  </template>
                </b-form-select>
              <!-- <select  class="form-control" >
                <option v-if="!successChk" disabled selected hidden :value="null" >
                  채널을 검색해주세요123
                </option> -->
                 <!-- <template v-for="(kcitem, kcidx) in kakaoChannelList" >
                  <option v-if="!kcitem.id" disabled selected :value="null">{{kcitem.name}}</option>
                  <option v-else-if="selectedKakaoChannel!=null && kcitem.searchId === selectedKakaoChannel.searchId":value="selectedKakaoChannel">{{selectedKakaoChannel.name + " (" + selectedKakaoChannel.searchId + ")"}}</option>
                  <option v-else :value="kcitem">{{kcitem.name + " (" + kcitem.searchId + ")"}}</option>
                </template> -->

              <!-- </select> -->

              </b-colxx>
            </b-row>
          </b-form-group>
          <b-form-group v-if="this.currentUser.userRole == 'BRAND_ADMIN'" label-cols="2" horizontal label="연동신청 매장" class="weight600">
            <b-row>
              <b-colxx xxs="12" xl="9">
                <b-table-simple v-if="partnerId == null" class="table b-table text-center" responsive show-empty>
                  <b-thead class="thead-light">
                    <b-tr>
                      <b-th>매장</b-th>
                      <b-th>매장 운영상태</b-th>
                      <b-th>카카오톡 연동여부</b-th>
                      <b-th>신청</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(item, idx) in kakaoStoreList" :key="idx">
                      <b-td class="align-middle">{{ item.storeName }}</b-td>
                      <b-td>
                        <h6 v-if="item.enabled" class="mb-0"><span class="badge badge-confirm">활성화</span></h6>
                        <h6 v-else class="mb-0"><span class="badge badge-disabled">비활성화</span></h6>
                      </b-td>
                      <b-td>
                        <div v-if="item.storePartnerLinkStatus != 'NONE' && item.storePartnerLinkStatus != null && item.storePartnerLinkStatus != undefined">
                          <h6 v-if="item.storePartnerLinkStatus === 'LINKED'" class="mb-0"><span class="badge badge-confirm">연동중</span></h6>
                          <h6 v-else class="mb-0"><span class="badge badge-disabled">신청중</span></h6>
                        </div>
                      </b-td>
                      <b-td class="align-middle">
                        <b-form-checkbox class="ml-2" v-if="item.enabled && (item.storePartnerLinkStatus == 'NONE' || item.storePartnerLinkStatus == null || item.storePartnerLinkStatus == undefined )" v-model="selectedStore" :value='item.storeCode'></b-form-checkbox>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
                <b-table-simple v-else class="table b-table text-center" responsive show-empty>
                  <b-thead class="thead-light">
                    <b-tr>
                      <b-th>매장</b-th>
                      <b-th>매장 운영상태</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(item, idx) in kakaoStoreList" :key="idx">
                      <b-td class="align-middle">{{ item.storeName }}</b-td>
                      <b-td>
                        <h6 v-if="item.enabled" class="mb-0"><span class="badge badge-confirm">활성화</span></h6>
                        <h6 v-else class="mb-0"><span class="badge badge-disabled">비활성화</span></h6>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-colxx>
            </b-row>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="파트너명(업체명)" class="weight600">
            <b-form-input maxlength="50" v-model="partnerName"></b-form-input>
            <span class="text-length-label">{{ getTextLength(partnerName) }} / 50 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="사업자명" class="weight600">
            <b-form-input maxlength="20" v-model="businessName"></b-form-input>
            <span class="text-length-label">{{ getTextLength(businessName) }} / 20 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="대표자명" class="weight600">
            <b-form-input maxlength="50" v-model="representativeName"></b-form-input>
            <span class="text-length-label">{{ getTextLength(representativeName) }} / 50 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="업태" class="weight600">
            <b-form-input maxlength="50" v-model="businessCategory"></b-form-input>
            <span class="text-length-label">{{ getTextLength(businessCategory) }} / 50 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="종목" class="weight600">
            <b-form-input maxlength="50" v-model="businessCategoryItem"></b-form-input>
            <span class="text-length-label">{{ getTextLength(businessCategoryItem) }} / 50 자</span>
          </b-form-group>
          <b-form-group label-cols="2" horizontal label="주소" class="weight600">
            <b-row>
              <b-colxx xxs="12" xl="8">
                <b-row class="mb-1">
                  <b-colxx xxs="6" class="pr-0">
                    <b-form-input type="text" v-model="zonecode" disabled></b-form-input>
                  </b-colxx>
                  <b-colxx xxs="6" class="pl-1">
                    <b-button variant="outline-primary default" @click="searchAddress">주소검색</b-button>
                    <modal_postcode ref="modal_postcode" @confirm="selectAddress" />
                  </b-colxx>
                </b-row>
                <b-row>
                  <b-colxx xxs="6" class="pr-0">
                    <b-form-input type="text" v-model="address" disabled></b-form-input>
                  </b-colxx>
                  <b-colxx xxs="6" class="pl-1">
                    <b-form-input type="text" v-model="detailAddress"></b-form-input>
                  </b-colxx>
                </b-row>
              </b-colxx>
            </b-row>
          </b-form-group>
          <b-row class="mt-4 justify-content-center">
            <b-button variant="outline-primary" class="mr-1" @click="back">취소</b-button>
            <b-button v-if="partnerId ==null" variant="success" @click="regKakaoReserveStore">입점신청</b-button>
            <b-button v-else variant="success" @click="updateKakaoReserveStore">입점신청</b-button>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>

import api from "@/constants/api";
import {mapGetters} from "vuex";
import StoreFileUploader from "@/components/Upload/StoreFileUploader.vue";
import modal_image from "@/views/shop/components/ModalImage.vue";
import {ContainerClient} from "@azure/storage-blob";
import modal_postcode from "@/views/shop/components/ModalPostcode.vue";

export default {
  components: {modal_postcode, modal_image, 'store-file-uploader': StoreFileUploader,},
  data() {
    return{
      partnerId: null,
      phoneData: false,
      kakaoId: "",

      tmpData:{},
      storeName : "",
      storeCode:"",
      token:"",
      kakaoChannelList:[],
      kakaoStoreList:[],
      storeListData:[],
      // selectedKakaoChannel: {
      //   name:'',
      //   id:null,
      //   searchId:''
      // },
      selectedKakaoChannel: null,
      partnerName: "",
      businessName: "",
      businessCode: "",
      firstUpdate: false,
      representativeName:"",
      businessCategory:"",
      businessCategoryItem:"",
      successChk: false,
      zonecode:"",
      address:"",
      detailAddress:"",
      bizNameNum: 0,
      selectedStore:[],
      tmpChannelId: null,
      tmpChannelSearchId: null,
      tmpChannelName: null,
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName','info'])

  },
  watch:{
    'smsRegisterDocumentUrl'(value) {
      console.log(value);
      this.browseText1 = this.smsRegisterDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload1();
        console.log(azureInfo)
      }
    },
    'smsCertificateDocumentUrl'(value) {
      console.log(value);
      this.browseText2 = this.smsCertificateDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload2();
        console.log(azureInfo)
      }
    },
    'businessCode'(val){
      val = val.replace(/[^0-9]/g, '').replace(/^(\d{3,3})(\d{2,2})(\d{0,5})$/, `$1-$2-$3`)
      this.businessCode = val;
      if(this.firstUpdate && !!this.partnerId) {
        this.firstUpdate = false;
      }else {
      this.selectedKakaoChannel = null;
      this.kakaoChannelList = [];
      this.successChk = false;

      }
    },


  },
  created() {
    // if(this.currentUser.userRole != "BRAND_ADMIN"){
    //   if(this.$route.query.storeCode !=null && this.$route.query.storeCode !=undefined && this.$route.query.storeCode != '' ){
    //     this.storeCode = this.$route.query.storeCode
    //     this.chkStore();
    //   }else{
    //     this.storeCode = this.info.storeCode
    //     this.chkStore();
    //   }
    // }else{
    //   this.storeCode = this.$route.query.storeCode
    //   this.chkStore();
    // }
    // if(this.$route.query.reg !=null && this.$route.query.reg !=undefined && this.$route.query.reg != '' ){
    //   this.regCode = this.$route.query.reg
    // }


  },
  beforeMount() {

  },
  mounted() {
    this.partnerId = this.$route.query.partnerId
    if(this.currentUser.userRole == 'BRAND_ADMIN'){
      this.getBrandStoreInKakaoReserve();
    }else{
      this.kakaoStoreList = []
    }


    if(!!this.partnerId){
      this.firstUpdate = true;
      this.getRequestedInfo();
    }

  },
  methods:{
    // chkStore(){
    //   let reqURL = ''
    //   reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getStoreInfo+`?storeCode=${this.storeCode}`)
    //   let params = {"storeCode": this.storeCode}
    //   this.$http.get(reqURL,params,  {
    //     headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
    //   }).then(res => {
    //     // ;
    //     if (res.data.code === "OK") {
    //       this.storeName = res.data.data.basicInfo.storeName
    //
    //     } else {
    //       throw 400
    //     }
    //   }).catch(err => {
    //     //alert(err.response.data.message);
    //
    //   })
    //
    //
    // },
    getTextLength(str) {
      return (!str || str.length === 0) ? 0 : str.length;
    },
    getSelectedChannelInfo() {
      return this.selectedKakaoChannel != null ? this.selectedKakaoChannel.name + " (" + this.selectedKakaoChannel.searchId + ")" : "오류 발생";
    },
    back(){
      this.$router.go(-1)
    },
    regKakaoReserveStore(){
      console.log(this.selectedStore)

      console.log(this.selectedKakaoChannel);


      if(!this.businessCode ){
        alert("사업자번호를 입력해주세요.")
        return
      }else if( this.businessCode.length<12){
        alert("사업자번호를 확인해주세요.")
        return
      }else if(!this.selectedKakaoChannel){
        alert("카카오톡 채널을 선택해주세요.")
        return
      }else if(this.currentUser.userRole =="BRAND_ADMIN" && this.selectedStore.length ==0){
        alert("연동신청 매장을 선택해주세요.")
        return
      } else if(!this.partnerName ){
        alert("파트너명(업체명)을 입력해주세요.")
        return
      } else if( this.partnerName.length>50){
        alert("파트너명(업체명)의 길이를 확인해주세요.")
        return
      } else if(!this.businessName){
        alert("사업자명을 입력해주세요.")
        return
      } else if( this.businessName.length>20){
        alert("사업자명의 길이를 확인해주세요.")
        return
      } else if(!this.representativeName){
        alert("대표자명을 입력해주세요.")
        return
      } else if(this.representativeName.length>50){
        alert("대표자명의 길이를 확인해주세요.")
        return
      } else if(!this.businessCategory){
        alert("업태를 입력해주세요.")
        return
      } else if(this.businessCategory.length>50){
        alert("업태의 길이를 확인해주세요.")
        return
      } else if(!this.businessCategoryItem){
        alert("종목을 입력해주세요.")
        return
      } else if(this.businessCategoryItem.length>50){
        alert("종목의 길이를 확인해주세요.")
        return
      } else if(!this.zonecode || !this.address || !this.detailAddress){
        alert("주소를 입력해주세요.")
        return
      }

      let brandInfo = JSON.parse(sessionStorage.getItem("BRAND_INFO"))
      console.log('this.info.storeCode')
      console.log(this.info.storeCode)
      const params = {
        storeCodes :this.currentUser.userRole =="BRAND_ADMIN"? this.selectedStore: [this.info.storeCode], //스토어 코드 리스트
        partnerName : this.partnerName, // 파트너이름
        bizNumber : this.businessCode, // 사업자번호
        bizName : this.businessName, // 사업자명
        representativeName: this.representativeName, // 대표자명
        zipCode: this.zonecode,
        baseAddress: this.address,
        detailAddress: this.detailAddress,
        businessCategory: this.businessCategory,
        businessCategoryItem: this.businessCategoryItem,
        channelSearchId: !this.partnerId? this.selectedKakaoChannel.searchId : this.tmpChannelSearchId,
        channelName: !this.partnerId? this.selectedKakaoChannel.name: this.tmpChannelName,
        brandName:brandInfo.brandName,
        brandCode:brandInfo.brandCode
      }
      //
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.regKakaoReserveStore)
      this.$http.post(reqURL,params,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if (res.data.code === "OK") {
          this.$router.push(`${'/'+this.siteName+'/booking/outer-connect-mng'}`)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    updateKakaoReserveStore(){
      console.log(this.selectedStore)

      console.log(this.selectedKakaoChannel);


      if(!this.businessCode ){
        alert("사업자번호를 입력해주세요.")
        return
      }else if( this.businessCode.length<12){
        alert("사업자번호를 확인해주세요.")
        return
      }else if(!this.selectedKakaoChannel){
        alert("카카오톡 채널을 선택해주세요.")
        return
      } else if(!this.partnerName ){
        alert("파트너명(업체명)을 입력해주세요.")
        return
      } else if( this.partnerName.length>50){
        alert("파트너명(업체명)의 길이를 확인해주세요.")
        return
      } else if(!this.businessName){
        alert("사업자명을 입력해주세요.")
        return
      } else if( this.businessName.length>20){
        alert("사업자명의 길이를 확인해주세요.")
        return
      } else if(!this.representativeName){
        alert("대표자명을 입력해주세요.")
        return
      } else if(this.representativeName.length>50){
        alert("대표자명의 길이를 확인해주세요.")
        return
      } else if(!this.businessCategory){
        alert("업태를 입력해주세요.")
        return
      } else if(this.businessCategory.length>50){
        alert("업태의 길이를 확인해주세요.")
        return
      } else if(!this.businessCategoryItem){
        alert("종목을 입력해주세요.")
        return
      } else if(this.businessCategoryItem.length>50){
        alert("종목의 길이를 확인해주세요.")
        return
      } else if(!this.zonecode || !this.address || !this.detailAddress){
        alert("주소를 입력해주세요.")
        return
      }

      let brandInfo = JSON.parse(sessionStorage.getItem("BRAND_INFO"))
      console.log('this.info.storeCode')
      console.log(this.info.storeCode)
      let params = null
      if(this.currentUser.userRole =="BRAND_ADMIN"){
        params = {
          storeCodes :this.selectedStore , //스토어 코드 리스트
          partnerName : this.partnerName, // 파트너이름
          bizNumber : this.businessCode, // 사업자번호
          bizName : this.businessName, // 사업자명
          representativeName: this.representativeName, // 대표자명
          zipCode: this.zonecode,
          baseAddress: this.address,
          detailAddress: this.detailAddress,
          businessCategory: this.businessCategory,
          businessCategoryItem: this.businessCategoryItem,
          channelSearchId: this.selectedKakaoChannel.searchId,
          channelName: this.selectedKakaoChannel.name,
          brandName:brandInfo.brandName,
          brandCode:brandInfo.brandCode
        }
      }else{
        params = {
          partnerName : this.partnerName, // 파트너이름
          bizNumber : this.businessCode, // 사업자번호
          bizName : this.businessName, // 사업자명
          representativeName: this.representativeName, // 대표자명
          zipCode: this.zonecode,
          baseAddress: this.address,
          detailAddress: this.detailAddress,
          businessCategory: this.businessCategory,
          businessCategoryItem: this.businessCategoryItem,
          channelSearchId: this.selectedKakaoChannel.searchId,
          channelName: this.selectedKakaoChannel.name,
          brandName:brandInfo.brandName,
          brandCode:brandInfo.brandCode
        }
      }

      //
      let reqURL = ''
      if (this.currentUser.userRole === 'BRAND_ADMIN') {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.regKakaoReserveStore)
      }else{
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.regKakaoReserveStoreStr)
      }

      this.$http.post(reqURL,params,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if (res.data.code === "OK") {
          this.$router.push(`${'/'+this.siteName+'/booking/outer-connect-mng'}`)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    mainIntroLength(eve){
      this.mainIntroNum = eve.srcElement._value.length
    },
    bizNameLength(eve){
      this.bizNameNum = eve.srcElement._value.length
    },
    searchBusinessCode(){
      this.kakaoChannelList = []
      this.selectedKakaoChannel = null;
      if(!this.businessCode){
        return
      }
      let chkVal = this.businessCode.replaceAll('-','')
      if(chkVal.length !== 10){
        alert("사업자번호가 올바르지 않습니다.")
        return
      }else{
        // kakaoChennelSearch
        this.successChk = true;
        this.kakaoChannelList = []

        let reqURL = ''
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.kakaoChennelSearch+ "?bizNumber=" + this.businessCode)
        this.$http.get(reqURL,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
              if(res.data.data.content.length <1) {
                this.successChk = false;
                alert("사업자번호에 해당되는 카카오톡 채널이 존재하지 않습니다. 사업자번호가 올바른지 다시 한번 확인해주세요.")

                return
              }
            this.partnerName = ""
            this.kakaoChannelList = res.data.data.content;
            this.kakaoChannelList.unshift({id:null, searchId:null , name:"예약상품을 노출할 채널을 선택해주세요."})

            // }
          } else {
            throw 400
          }
        }).catch(err => {
          this.kakaoChannelList = []
          alert(err.response.data.message);
        })
      }

    },
    searchBusinessCodeUpdate(){
      this.kakaoChannelList = []
      console.log(this.firstUpdate);
      if(!this.businessCode){
        return
      }
      let chkVal = this.businessCode.replaceAll('-','')
      if(chkVal.length !== 10){
        alert("사업자번호가 올바르지 않습니다.")
        return
      }else{
        // kakaoChennelSearch
        this.successChk = true;
        this.kakaoChannelList = []

        let reqURL = ''
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.kakaoChennelSearch+ "?bizNumber=" + this.businessCode)
        this.$http.get(reqURL,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
              if(res.data.data.content.length <1) {
                this.successChk = false;
                alert("사업자번호에 해당되는 카카오톡 채널이 존재하지 않습니다. 사업자번호가 올바른지 다시 한번 확인해주세요.")

                return
              }
              this.kakaoChannelList = res.data.data.content;
              this.kakaoChannelList.unshift({id:null, searchId:null , name:"예약상품을 노출할 채널을 선택해주세요."})
              // if(this.partnerId){



              //   let searchItem = this.kakaoChannelList.filter(item=>{ return item.name == this.tmpChannelName})
              //   console.log(searchItem)
              //   this.selectedKakaoChannel.name = searchItem[0].name
              //   this.selectedKakaoChannel.id = searchItem[0].id
              //   this.selectedKakaoChannel.searchId = searchItem[0].searchId
              // }

            // }
          } else {
            throw 400
          }
        }).catch(err => {
          this.kakaoChannelList = []
          alert(err.response.data.message);
        })
      }

    },
    searchAddress() {
      this.$refs.modal_postcode.open()
    },
    selectAddress(data) {
      this.detailAddress = data.data.detailAddress
      this.address = data.data.roadAddress
      this.zonecode = data.data.zipCode
    },
    initKakaoPartner(){
      this.partnerName = this.selectedKakaoChannel.name
    },

    //
    getBrandStoreInKakaoReserve(){
      this.kakaoStoreList = []

      let reqURL = ''
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getPartnerBrandStoreList)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {

          const tmpKakaoStoreList = res.data.data;
          if(this.partnerId){
            this.kakaoStoreList = tmpKakaoStoreList.filter(item=> {
              return item.partnerId == this.partnerId
            })
          }else{
            this.kakaoStoreList = res.data.data;
          }

        } else {
          throw 400
        }
      }).catch(err => {
        this.kakaoStoreList = []
        alert(err.response.data.message);
      })
    },
    getRequestedInfo(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoReserveReqInfo + `?partnerId=${this.partnerId}`)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          let data =  res.data.data

          this.partnerName = res.data.data.partnerName
          this.businessCode = data.bizNumber
          this.businessName = data.bizName
          this.representativeName = data.representativeName
          this.zonecode = data.zipCode
          this.address = data.baseAddress
          this.detailAddress = data.detailAddress
          this.businessCategory = data.businessCategory
          this.businessCategoryItem = data.businessCategoryItem
          // 팝업 에러 수정 부분
          this.tmpChannelId = data.id
          this.tmpChannelSearchId = data.channelSearchId
          console.log(data.channelName)
          this.tmpChannelName = data.channelName
          this.selectedKakaoChannel = {
                name:'',
                id:null,
                searchId:''
              }
          this.selectedKakaoChannel.name = data.channelName;
          this.selectedKakaoChannel.searchId = data.channelId;
          console.log(this.selectedKakaoChannel);
          //여기까지
          this.searchBusinessCodeUpdate();
          // this.selectedKakaoChannel.id = !data.id ? '' : data.id
          // this.selectedKakaoChannel.name = data.channelName

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.message);
      })
    }
  }
}
</script>

<style>

</style>
